/**
 * Svelte store for tracking the active household (Issue #72)
 * Persists selection to localStorage
 */
import { writable } from 'svelte/store';

const STORAGE_KEY = 'plc_active_household_id';

function createActiveHouseholdStore() {
  const stored =
    typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) || 'Global' : 'Global';

  const { subscribe, set } = writable<string>(stored);

  return {
    subscribe,

    setActiveHousehold(id: string): void {
      localStorage.setItem(STORAGE_KEY, id);
      set(id);
    },

    reset(): void {
      localStorage.removeItem(STORAGE_KEY);
      set('Global');
    },
  };
}

export const activeHouseholdStore = createActiveHouseholdStore();
